module.exports = __webpack_public_path__ + "img/download_r1.c3273342.jpg";